import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/feature/SEOHead';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { brandStory, testimonials } from '@/mocks/articles';
import { useState } from 'react';

export default function AboutPage() {
  const [reviewIndex, setReviewIndex] = useState(0);
  const t = testimonials[reviewIndex % testimonials.length];

  const schemaData = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        name: '51今日吃瓜网',
        url: 'https://www.51chigua.com',
        description: '全网最新吃瓜资源与爆料入口',
        foundingDate: '2024',
      },
      {
        '@type': 'WebPage',
        name: '关于51今日吃瓜网',
        description: '了解51今日吃瓜网的品牌故事、用户口碑和联系方式',
        url: 'https://www.51chigua.com/about',
      },
      {
        '@type': 'FAQPage',
        mainEntity: [
          {
            '@type': 'Question',
            name: '51今日吃瓜网是一个什么样的平台？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '51今日吃瓜网是国内领先的娱乐资讯聚合平台，致力于为吃瓜群众提供全网最新、最全、最真的吃瓜资源和爆料信息。',
            },
          },
          {
            '@type': 'Question',
            name: '51吃瓜网的信息来源可靠吗？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '我们坚持追根溯源，通过多源交叉验证确保信息的真实性和时效性，编辑团队由资深娱乐记者和数据挖掘专家组成。',
            },
          },
          {
            '@type': 'Question',
            name: '如何向51吃瓜网投稿爆料？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '您可以通过关于我们页面上的联系方式与我们取得联系，提供您掌握的独家爆料信息。',
            },
          },
        ],
      },
    ],
  };

  return (
    <>
      <SEOHead
        title="关于51今日吃瓜网 - 品牌介绍与联系方式"
        description="了解51今日吃瓜网的品牌故事、用户口碑和联系方式。51今日吃瓜网是国内领先的娱乐资讯聚合平台，致力于为吃瓜群众提供全网最新、最全、最真的吃瓜资源。"
        keywords="51吃瓜网关于我们,51吃瓜品牌介绍,51吃瓜联系方式,51吃瓜网口碑"
        canonicalUrl="/about"
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
      />
      <Navbar />

      <main>
        <section className="bg-background-100 pt-28 pb-14 md:pb-20">
          <div className="mx-auto max-w-[1280px] px-6 md:px-10">
            <Breadcrumb items={[{ name: '关于我们' }]} />

            <div className="mt-8 flex flex-col lg:flex-row gap-8 lg:gap-16 items-start">
              <div className="flex-1">
                <span className="text-xs font-semibold text-foreground-400 uppercase tracking-wider font-label">
                  关于51吃瓜网
                </span>
                <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-black text-foreground-950 mt-3 leading-tight">
                  {brandStory.title}
                </h1>
                <p className="mt-4 text-foreground-500 text-sm md:text-base max-w-xl leading-relaxed">
                  {brandStory.subtitle}
                </p>
              </div>
            </div>

            <div className="mt-10 flex gap-4">
              <div className="w-[45%] rounded-xl overflow-hidden h-[220px] md:h-[280px]">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20editorial%20newsroom%20with%20multiple%20monitors%20displaying%20entertainment%20news%2C%20professional%20workspace%20with%20warm%20lighting%2C%20dark%20wood%20desk%2C%20journalists%20working%20atmosphere%2C%20cinematic%20environment%2C%20warm%20amber%20and%20dark%20brown%20tones%2C%20editorial%20photography%20style%2C%20professional%20media%20company%20vibe&width=800&height=600&seq=about-brand-01&orientation=landscape"
                  alt="51今日吃瓜网品牌形象"
                  title="51今日吃瓜网 - 专业吃瓜资讯平台"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="w-[55%] rounded-xl overflow-hidden h-[220px] md:h-[280px]">
                <img
                  src="https://readdy.ai/api/search-image?query=Team%20of%20entertainment%20journalists%20collaborating%20in%20a%20modern%20office%2C%20large%20screens%20with%20social%20media%20feeds%2C%20breaking%20news%20atmosphere%2C%20professional%20media%20team%2C%20warm%20office%20lighting%2C%20dark%20modern%20interior%2C%20editorial%20photography%20style%2C%20collaborative%20workspace&width=900&height=600&seq=about-brand-02&orientation=landscape"
                  alt="51今日吃瓜网团队"
                  title="51今日吃瓜网编辑团队"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>

            <div className="mt-14 max-w-3xl">
              <p className="text-foreground-700 text-base leading-relaxed mb-6">
                {brandStory.longText}
              </p>
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 bg-background-50">
          <div className="mx-auto max-w-[1280px] px-6 md:px-10">
            <div className="max-w-2xl mx-auto text-center mb-10">
              <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900">
                （行业认可）
              </h2>
            </div>

            <div className="max-w-2xl mx-auto relative">
              <div className="flex items-start gap-6">
                <div className="flex-shrink-0 mt-1">
                  <div className="px-4 py-2 bg-foreground-900 text-accent-500 rounded-full text-sm font-bold flex items-center gap-1.5 whitespace-nowrap">
                    <i className="ri-star-fill text-accent-500 text-xs"></i>
                    {t.rating}
                  </div>
                </div>
                <div className="flex-1">
                  <blockquote className="font-heading text-lg md:text-xl text-foreground-700 leading-relaxed italic">
                    &ldquo;{t.comment}&rdquo;
                  </blockquote>
                  <div className="mt-6 flex items-center gap-3">
                    <div className="w-10 h-10 rounded-full overflow-hidden">
                      <img src={t.avatar} alt={t.username} className="w-full h-full object-cover" />
                    </div>
                    <div>
                      <p className="text-sm font-semibold text-foreground-900">{t.username}</p>
                      <p className="text-xs text-foreground-400">{t.platform}</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="absolute bottom-0 right-0 flex items-center gap-2">
                <button
                  onClick={() => setReviewIndex((c) => (c === 0 ? testimonials.length - 1 : c - 1))}
                  className="w-10 h-10 flex items-center justify-center rounded-lg border border-foreground-300 text-foreground-600 hover:bg-background-200 transition-colors cursor-pointer"
                  aria-label="上一条评价"
                >
                  <i className="ri-arrow-left-s-line text-lg"></i>
                </button>
                <button
                  onClick={() => setReviewIndex((c) => (c === testimonials.length - 1 ? 0 : c + 1))}
                  className="w-10 h-10 flex items-center justify-center rounded-lg bg-foreground-900 text-white hover:bg-foreground-800 transition-colors cursor-pointer"
                  aria-label="下一条评价"
                >
                  <i className="ri-arrow-right-s-line text-lg"></i>
                </button>
              </div>
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 bg-background-50">
          <div className="mx-auto max-w-[1280px] px-6 md:px-10 text-center">
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-black text-foreground-950">
              爆料投稿与商务合作
            </h2>
            <p className="mt-3 text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
              如果您有独家爆料线索或商务合作意向，欢迎与我们取得联系
            </p>

            <div className="mt-8 flex flex-wrap items-center justify-center gap-4">
              <div className="inline-flex items-center gap-2 px-5 py-3 bg-primary-500 text-white rounded-full text-sm font-semibold cursor-pointer whitespace-nowrap">
                <i className="ri-mail-line"></i>
                投稿邮箱：tips@51chigua.com
              </div>
              <div className="inline-flex items-center gap-2 px-5 py-3 bg-secondary-500 text-white rounded-full text-sm font-semibold cursor-pointer whitespace-nowrap">
                <i className="ri-phone-line"></i>
                合作热线：400-888-5151
              </div>
            </div>

            <div className="mt-14 overflow-hidden">
              <div className="flex gap-8 items-center justify-center flex-wrap opacity-30">
                <span className="text-foreground-500 text-xs font-semibold uppercase tracking-widest font-label">合作伙伴</span>
                <span className="text-foreground-400 text-sm font-semibold font-label">娱乐头条</span>
                <span className="text-foreground-400 text-sm font-semibold font-label">星闻速递</span>
                <span className="text-foreground-400 text-sm font-semibold font-label">八卦周刊</span>
                <span className="text-foreground-400 text-sm font-semibold font-label">热点追踪</span>
                <span className="text-foreground-400 text-sm font-semibold font-label">娱记联盟</span>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}